import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyDa_4ivEwl6Sc416P37cR1K5wMHfMS0Ff4",
  authDomain: "troytrade-invest-app.firebaseapp.com",
  projectId: "troytrade-invest-app",
  storageBucket: "troytrade-invest-app.firebasestorage.app",
  messagingSenderId: "320083031697",
  appId: "1:320083031697:web:a88b9e35dea7ee3bd97130"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app, "us-central1");